import React from "react";
import "../../../../css/Turismo/turismo.css";

const MuseoMalvinas = () => (
  <div>
    <div
      style={{
        backgroundImage: `url(${require("../../../img/Museo-1.jpg")})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: 450,
        marginBottom: 30,
      }}
    />
    <div className="container">
      <h1 className="text-center"><strong>MUSEO NACIONAL DE MALVINAS</strong></h1>
      <br />
      <div className="text-center">
        <img
          src={require("../../../img/destacados/visitas-museo.png")}
          alt="Información para visitas al Museo Nacional de Malvinas"
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </div>
      <div className="text-center" style={{ margin: "30px 0" }}>
        <a href="/turismo" className="btn btn-primary">Volver a Turismo</a>
      </div>
    </div>
  </div>
);

export default MuseoMalvinas;
